import { TezaurusList, TezaurusListApi } from 'tezaury-frontend-ts-axios';
import { AxiosRequestHeaders } from 'axios';
import { ClientResponse } from '../../model/ClientResponse';
import apiConfiguration from '../configuration/apiConfiguration';
import Tezaurus from '../../model/Tezaurus';
import { tezauryPrefixPath } from '../configuration/apiConfigurationConstants';

const client = new TezaurusListApi(apiConfiguration(tezauryPrefixPath));

function map(data: TezaurusList): Array<Tezaurus> {
  return data.tezaurusList.map(tezaurus => ({
    uuid: tezaurus.uuid,
    nazov: tezaurus.nazov,
  }));
}

// eslint-disable-next-line import/prefer-default-export
export const fetchTezaurusList = async (options?: { headers?: AxiosRequestHeaders }):
  Promise<ClientResponse<Array<Tezaurus>>> => {
  const { data, status } = await client.getTezaurusList(options);
  return { data: map(data), responseCode: status };
};
